import { render, staticRenderFns } from "./CheckTableBodyItem.vue?vue&type=template&id=c67737e2&scoped=true&"
import script from "./CheckTableBodyItem.vue?vue&type=script&lang=js&"
export * from "./CheckTableBodyItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckTableBodyItem.vue?vue&type=style&index=0&id=c67737e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67737e2",
  null
  
)

export default component.exports